import React from 'react';
import { DetailBlock } from './StyleUserDetailBlock';

function RednderTextUserData(elem) {
  return <DetailBlock key={elem.title + elem.value}>{elem.title + elem.value}</DetailBlock>;
}

export default RednderTextUserData;



// WEBPACK FOOTER //
// ./src/Components/MenuGenerator/UserDetailBlock/RenderTextUserData.jsx